import addressesForClaim2 from "../assets/addresses/2.json";
import addressesForClaim3 from "../assets/addresses/3.json";
import addressesForClaim5 from "../assets/addresses/5.json";
import addressesForClaim6 from "../assets/addresses/6.json";
import addressesForClaim7 from "../assets/addresses/7.json";
import addressesForClaim8 from "../assets/addresses/8.json";
import addressesForClaim9 from "../assets/addresses/9.json";
import addressesForClaim10 from "../assets/addresses/10.json";
import addressesForClaim11 from "../assets/addresses/11.json";
import addressesForClaim12 from "../assets/addresses/12.json";
import addressesForClaim13 from "../assets/addresses/13.json";
import addressesForClaim14 from "../assets/addresses/14.json";
import addressesForClaim15 from "../assets/addresses/15.json";
import addressForClaim16 from "../assets/addresses/16.json";
import addressForClaim17 from "../assets/addresses/17.json";
import addressForClaim18 from "../assets/addresses/18.json";
import addressesForClaim19 from "../assets/addresses/19.json";
import addressesForClaim20 from "../assets/addresses/20.json";
import addressesForClaim21 from "../assets/addresses/21.json";
import addressesForClaim22 from "../assets/addresses/22.json";
import addressesForClaim23 from "../assets/addresses/23.json";

export const randomHex = [
  "0xd5b5f64d66cc31c622be4bdc9e83b48fafd599c8e2dcd4402032ab1c9f89dece",
];

const addressesForWrongTree = [
  ["0x6aa7eF6F4c812f9F5F60b8aC36562c8210AEA58d"],
  ["0x6aa7eF6F4c812f9F5F60b8aC36562c8210AEA58d"],
];

export const treeLeaves = [
  addressesForWrongTree,
  addressesForWrongTree,
  addressesForClaim2,
  addressesForClaim3,
  addressesForWrongTree,
  addressesForClaim5,
  addressesForClaim6,
  addressesForClaim7,
  addressesForClaim8,
  addressesForClaim9,
  addressesForClaim10,
  addressesForClaim11,
  addressesForClaim12,
  addressesForClaim13,
  addressesForClaim14,
  addressesForClaim15,
  addressForClaim16,
  addressForClaim17,
  addressForClaim18,
  addressesForClaim19,
  addressesForClaim20,
  addressesForClaim21,
  addressesForClaim22,
  addressesForClaim23,
];
